// Income & Expense Management page and its dialogs. Excel files and stored
// values ('Alındı', 'Beklemede', 'Ödendi', 'Pasif', source/category options) stay Turkish.
const budget = {
  page: {
    title: 'Income & Expense Management',
    subtitle: 'E-invoice income and expenses, payment states and statistics.',
  },
  types: {
    income: 'Income',
    expense: 'Expense',
  },
  status: {
    received: 'Received',
    pending: 'Pending',
    paid: 'Paid',
    cancelled: 'Cancelled',
    waiting: 'Awaiting payment',
    active: 'Active',
    passive: 'Inactive',
  },
  common: {
    cancel: 'Cancel',
    giveUp: 'Cancel',
  },
  actions: {
    addIncome: 'New Income',
    addExpense: 'New Expense',
    importIncome: 'Import Income Excel',
    importIncomeHint: 'Import income from an outgoing e-invoice Excel file',
    importExpense: 'Import Expense Excel',
    importExpenseHint: 'Import expenses from an incoming e-invoice Excel file',
    excel: 'Download Table',
    excelHint: 'Download the filtered income and expenses as Excel',
    deleteAll: 'Delete All (Test)',
    deleteAllHint: 'TEST: delete every income and expense record',
  },
  stats: {
    receivedIncome: 'Received Income (Active)',
    receivedIncomeShort: 'Received',
    pendingIncome: 'Pending Income (Active)',
    pendingIncomeShort: 'Pending income',
    paidExpense: 'Completed Payments (Active Expenses)',
    paidExpenseShort: 'Paid expenses',
    pendingExpense: 'Pending Payments (Active Expenses)',
    pendingExpenseShort: 'Pending expenses',
  },
  tabs: {
    label: 'List',
    income: 'Income List',
    incomeShort: 'Income',
    expense: 'Expense List',
    expenseShort: 'Expenses',
  },
  toolbar: {
    search: 'Search by title, GİB no, ETTN, TCKN/VKN…',
    searchShort: 'Search invoices…',
    dateRange: 'Date range',
    dateRangeHint: 'Filters by the record date (document date)',
    startDate: 'Start date',
    endDate: 'End date',
  },
  table: {
    incomeLabel: 'Income list',
    expenseLabel: 'Expense list',
    emptyIncome: 'No income matches the filters',
    emptyIncomeNone: 'No income records yet',
    emptyExpense: 'No expenses match the filters',
    emptyExpenseNone: 'No expense records yet',
    rangeOf: 'of {{total}} records',
    ofTotal: 'out of {{total}} in total',
    jump: 'Go to page',
  },
  columns: {
    customerName: 'Customer Title',
    senderName: 'Title',
    gib: 'GİB Number',
    draft: 'Draft No',
    scenario: 'Scenario',
    invoiceType: 'Invoice Type',
    createdDate: 'Created On',
    createdTime: 'Created At',
    documentDate: 'Document Date',
    documentTime: 'Document Time',
    customerTax: 'Customer TCKN/VKN',
    senderTax: 'Sender TCKN/VKN',
    customerTag: 'Customer Tag',
    senderTag: 'Sender Tag',
    amount: 'Amount',
    currency: 'Currency',
    envelopeUuid: 'Envelope UUID',
    envelopeStatus: 'Envelope Status',
    ettn: 'ETTN',
    discount: 'Discount',
    extraCosts: 'Non-invoice Costs',
    lineCount: 'Line Count',
    lineTotal: 'Unit Price × Quantity',
    payable: 'Payable Amount',
    taxExcluded: 'Amount excl. Taxes',
    taxIncluded: 'Amount incl. Taxes',
    paymentStatus: 'Payment Status',
    category: 'Category',
  },
  panel: {
    label: 'Selected record',
    heading: 'Record',
    toggleStatus: 'Change Status',
    statusLocked: 'This status cannot be changed',
    edit: 'Edit',
    delete: 'Delete',
    deleteHint: 'Delete the record',
    deactivate: 'Set Inactive',
    deactivateHint: 'Set this record inactive',
    activate: 'Set Active',
    activateHint: 'Set this record active',
    attachment: 'Attachment {{index}} / {{count}}',
    attachmentSize: 'Attachment {{index}} / {{count}} · {{size}} KB',
  },
  delete: {
    title: 'Delete Record',
    message: 'Are you sure you want to delete {{name}} permanently? This cannot be undone.',
    confirm: 'Yes, Delete',
  },
  deleteAll: {
    title: 'Delete All Records',
    message: 'EVERY income and expense record in the budget table will be deleted permanently. This cannot be undone. Do you want to continue?',
    confirm: 'Yes, Delete All',
    deleting: 'Deleting…',
  },
  charts: {
    title: 'Statistics',
    subtitle: 'All income and expense records',
    incomeExpense: 'Income and Expense Split',
    paymentStatus: 'Payment Status',
    category: 'Category Split',
    monthly: 'Monthly Trend',
    totalAmount: 'Total Amount (₺)',
    other: 'Other',
  },
  form: {
    titleAddIncome: 'Add New Income',
    titleAddExpense: 'Add New Expense',
    subtitleAdd: 'Enter the e-invoice details and attach files if you like',
    sections: {
      invoice: 'Invoice Details',
      dates: 'Date & Time',
      customer: 'Customer Details',
      sender: 'Sender Details',
      amounts: 'Amounts',
      status: 'Status',
      files: 'Attach Files (Optional)',
    },
    unvanPlaceholder: 'Title',
    scenarioPlaceholder: 'Commercial, Basic…',
    invoiceTypePlaceholder: 'SATIS, TEVKIFAT…',
    activeStatus: 'Active Status',
    dropTitle: 'Drag files here or click',
    dropHint: 'PDF, Word, Excel, images and other files',
    removeFile: 'Remove file',
    reset: 'Reset',
    addIncome: 'Add Income',
    addExpense: 'Add Expense',
    adding: 'Adding…',
    titleEditIncome: 'Edit Income',
    titleEditExpense: 'Edit Expense',
    incomeName: 'Income Name',
    incomeNamePlaceholder: 'Enter the income name',
    expenseName: 'Expense Name',
    expenseNamePlaceholder: 'Enter the expense name',
    incomeSource: 'Income Source',
    incomeCategory: 'Income Category',
    source: 'Source',
    spender: 'Spent By',
    expenseType: 'Expense Type',
    category: 'Category',
    amountPlaceholder: 'Enter the amount',
    incomeDate: 'Income Date',
    expenseDate: 'Expense Date',
    status: 'Status',
    choose: 'Please select',
    updateIncome: 'Update Income',
    updateExpense: 'Update Expense',
    updating: 'Updating…',
  },
  import: {
    titleIncome: 'Import Income from Excel',
    titleExpense: 'Import Expenses from Excel',
    subtitleIncome: 'Outgoing e-invoice list; identical records are skipped',
    subtitleExpense: 'Incoming e-invoice list; identical records are skipped',
    dropIncome: 'Drag the outgoing e-invoice Excel file here or click',
    dropExpense: 'Drag the incoming e-invoice Excel file here or click',
    formats: 'Supported formats: .xlsx, .xls, .csv',
    ready_one: '{{count}} new row will be imported. Total amount: {{total}} ₺',
    ready_other: '{{count}} new rows will be imported. Total amount: {{total}} ₺',
    customer: 'Customer',
    sender: 'Sender',
    date: 'Date',
    amount: 'Amount',
    currencyShort: 'Cur.',
    more_one: '…and {{count}} more row',
    more_other: '…and {{count}} more rows',
    checking: 'Comparing with existing records…',
    dupExisting_one: '{{count}} row is identical to an existing record and will be skipped.',
    dupExisting_other: '{{count}} rows are identical to existing records and will be skipped.',
    dupInFile_one: '{{count}} row repeats inside the file and will be skipped.',
    dupInFile_other: '{{count}} rows repeat inside the file and will be skipped.',
    nothingNew: 'There are no new rows to add.',
    progress: 'Importing: {{done}} / {{total}}',
    import: 'Import',
    importCount: 'Import ({{count}})',
    importing: 'Importing…',
    errorEmpty: 'The Excel file looks empty.',
    errorFormatIncome: 'This file is not in the expected income format. The TUTAR and UNVAN columns were not found.',
    errorFormatExpense: 'This file is not in the expected expense format. The TUTAR and GÖNDERİCİ UNVAN columns were not found.',
    errorRead: 'The Excel file could not be read or compared with the existing records.',
  },
  toast: {
    loadError: 'Budgets could not be loaded',
    employeesError: 'Employees could not be loaded',
    nothingToExport: 'There is no data to export.',
    excelDone: 'Excel file downloaded',
    excelError: 'The Excel file could not be downloaded',
    addError: 'The record could not be added',
    statusLocked: 'This status cannot be changed.',
    statusUpdated: 'Status set to "{{status}}".',
    statusError: 'The status could not be updated.',
    selectToEdit: 'Please select a record to edit.',
    nothingToDelete: 'There are no records to delete.',
    deletedAll_one: '{{count}} record deleted.',
    deletedAll_other: '{{count}} records deleted.',
    deleteAllError: 'The records could not be deleted.',
    deleted: 'Record deleted.',
    deleteError: 'The record could not be deleted.',
    activeUpdated: 'Record marked as "{{status}}".',
    activeError: 'The active state could not be updated.',
    pageJumpInvalid: 'Please enter a page number between 1 and {{max}}.',
    incomeAdded: 'Income added!',
    incomeAddError: 'The income could not be added!',
    expenseAdded: 'Expense added!',
    expenseAddError: 'The expense could not be added!',
    incomeNotFound: 'The income to edit was not found!',
    incomeUpdated: 'Income updated!',
    incomeUpdateError: 'The income could not be updated!',
    expenseNotFound: 'The expense to edit was not found!',
    expenseUpdated: 'Expense updated!',
    expenseUpdateError: 'The expense could not be updated!',
    invalidExcel: 'Please choose a valid Excel file (xlsx, xls, csv).',
    allExist: 'Every row is already recorded. No new records were added.',
    incomeImported_one: '{{count}} income record imported.',
    incomeImported_other: '{{count}} income records imported.',
    expenseImported_one: '{{count}} expense record imported.',
    expenseImported_other: '{{count}} expense records imported.',
    skippedRows_one: '{{count}} row was skipped because it is already recorded.',
    skippedRows_other: '{{count}} rows were skipped because they are already recorded.',
    importError: 'Something went wrong during the import.',
  },
};

export default budget;
